import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import Header from "../components/Header";
import Footer from "../components/Footer";
import ProtectedRoute from "../components/ProtectedRoute";
import { routes } from './routes';
import LoadingSpinner from '../components/LoadingSpinner';

const pages = import.meta.glob([
  '../pages/**/*.jsx',
  '!../pages/core/home/MerchPlaygroundCanvas.jsx',
  '!../pages/core/home/StudioCanvas2D.jsx',
  '!../pages/core/home/StudioGarmentSvg.jsx',
  '!../pages/core/home/StudioMockupComposer.jsx',
  '!../pages/core/home/StudioPreviewPanel.jsx',
]);
const routeComponents = Object.keys(pages).reduce((acc, path) => {
  const name = path
    .replace('../pages/', '')
    .replace('.jsx', '')
    .replace(/\//g, '_')
    .replace('._', '');

  acc[name.toLowerCase()] = lazy(pages[path]);
  return acc;
}, {});

export function AppRoutes() {
  return routes.map(({ url, view, base, auth }) => {
    const Component = routeComponents[view.toLowerCase()];
    if (!Component) {
      console.error(`Component not found for view: ${view}`);
      return null;
    }

    const element = auth ? (
      <ProtectedRoute>
        <Component />
      </ProtectedRoute>
    ) : (
      <Component />
    );

    return (
      <Route
        key={url}
        path={url}
        element={
          <>
            {!base && <Header />}
            {!base ? (
              <div className="w-full bg-[#111] min-h-[calc(100vh-200px)] relative">
                  <Suspense fallback={
                    <div className="flex min-h-[calc(100vh-220px)] items-center justify-center text-center">
                      <LoadingSpinner />
                    </div>
                  }>
                    {element}
                  </Suspense>
              </div>
            ) : (
              <Suspense fallback={
                <div className="flex min-h-screen items-center justify-center text-center">
                  <LoadingSpinner />
                </div>
              }>
                {element}
              </Suspense>
            )}
            {!base && <Footer />}
          </>
        }
      />
    );
  });
}
